import { render, staticRenderFns } from "./Card3.vue?vue&type=template&id=1d88e072&scoped=true&"
import script from "./Card3.vue?vue&type=script&lang=js&"
export * from "./Card3.vue?vue&type=script&lang=js&"
import style0 from "./Card3.vue?vue&type=style&index=0&id=1d88e072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d88e072",
  null
  
)

export default component.exports